module.exports = __webpack_public_path__ + "assets/icon-hospitalBg.068ab0f4.svg";